import { faChartLine } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';

const EmptyMessage = () => (
  <>
    <FormattedMessage id="project.overview.planned_vs_actual.empty.help_text" />{' '}
    <Link to="/templates">
      <FormattedMessage id="project.overview.planned_vs_actual.empty.cta" />
    </Link>
  </>
);

export const EmptyContent: FC = () => (
  <CardEmptyState
    image={<EmptyStateIcon icon={faChartLine} />}
    message={<EmptyMessage />}
  />
);
